<template v-else-if="this.storageApiResponse">
  <h1>{{ $t("storage.sectionTitle") }}</h1>
  <p>{{ $t("storage.subsection") }}</p>
  <StorageItem
    v-for="storageItem in storageApiResponse"
    :key="storageItem.id"
    :storage-item-info="storageItem"
  >
  </StorageItem>
</template>

<script>
import StorageItem from "../components/storage/StorageItem.vue";
import StorageService from "../service/StorageService.js";

export default {
  data() {
    return {
      storageService: null,
      storageApiResponse: null,
    };
  },
  created() {
    this.storageService = new StorageService();
  },
  components: {
    StorageItem,
  },
  computed: {
    access_token: function() {
      return this.$store.getters["userdata/getAccessToken"];
    },
    locale: function() {
      return this.$store.getters["preferences/locale"];
    },
    user_id: function() {
      return this.$store.getters["profile/id"];
    },
  },
  async mounted() {
    this.storageApiResponse = await this.storageService.getStorageInfo(
      this.access_token,
      this.user_id
    );
    this.$store.commit("storage/setStorage", this.storageApiResponse);
  },
};
</script>

<style></style>
